"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Link = _interopRequireDefault(require("../Link"));
var _loginMenuOption = require("./login.menu.option.proptypes");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LoginOptionContainer = _styledComponents.default.div.withConfig({
  displayName: "LoginMenuOption__LoginOptionContainer",
  componentId: "sc-a99ke2-0"
})(["outline:0 none;background-color:", ";border-bottom:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme,
    background = _ref.background;
  return theme.backgroundColor[background];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyLight;
});
var CustomLink = (0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "LoginMenuOption__CustomLink",
  componentId: "sc-a99ke2-1"
})(["display:flex;justify-content:flex-start;", " &:hover{background-color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return (0, _styledComponents.css)(["padding:", " ", ";align-items:center;"], theme.space.XSmall, theme.space.standard);
}, function (_ref4) {
  var theme = _ref4.theme,
    hoverBackground = _ref4.hoverBackground;
  return theme.backgroundColor[hoverBackground];
});
var LoginMenuOptionData = /*#__PURE__*/_react.default.memo(function (_ref5) {
  var labelTextColor = _ref5.labelTextColor,
    label = _ref5.label,
    redirectUrl = _ref5.redirectUrl,
    target = _ref5.target,
    hoverBackground = _ref5.hoverBackground,
    textType = _ref5.textType,
    accessible = _ref5.accessible,
    id = _ref5.id,
    stopPropagation = _ref5.stopPropagation;
  return /*#__PURE__*/_react.default.createElement(CustomLink, {
    accessible: accessible,
    customProperties: {
      id: id
    },
    hoverUnderlined: false,
    href: redirectUrl,
    target: target,
    hoverBackground: hoverBackground,
    stopPropagation: stopPropagation
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: false,
    type: textType,
    bold: true,
    color: labelTextColor
  }, label));
});
LoginMenuOptionData.propTypes = _loginMenuOption.LoginMenuOptionDataPropTypes.PropTypes;
var LoginMenuOption = function LoginMenuOption(props) {
  var data = props.data,
    theme = props.theme,
    className = props.className,
    background = props.background,
    labelTextColor = props.labelTextColor,
    hoverBackground = props.hoverBackground,
    accessible = props.accessible,
    customProperties = props.customProperties,
    textType = props.textType,
    stopPropagation = props.stopPropagation;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var arr = [];
  if (data) {
    // forEach is not used because of performance issues of callbacks
    for (var i = 0; i < data.length; i += 1) {
      arr.push( /*#__PURE__*/_react.default.createElement(LoginMenuOptionData, {
        key: "".concat(data[i].id),
        id: "".concat(data[i].id),
        labelTextColor: labelTextColor,
        label: data[i].label,
        redirectUrl: data[i].redirectUrl,
        target: data[i].newTab === 'TRUE' ? 'tab' : 'parent',
        tabIndex: tabIndex,
        textType: textType,
        accessible: accessible,
        hoverBackground: hoverBackground,
        stopPropagation: stopPropagation
      }));
    }
  }
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(LoginOptionContainer, (0, _extends2.default)({
      id: "login-menu-option",
      theme: themeContext,
      className: className,
      background: background
    }, customProperties), arr);
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
LoginMenuOption.propTypes = _loginMenuOption.LoginMenuOptionProptypes.PropTypes;
LoginMenuOption.defaultProps = _loginMenuOption.LoginMenuOptionProptypes.DefaultProps;
var _default = LoginMenuOption;
exports.default = _default;